import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import TransportWebHid from '@ledgerhq/hw-transport-webhid';
import { BaseSignerWalletAdapter, WalletConnectionError, WalletDisconnectedError, WalletDisconnectionError, WalletNotConnectedError, WalletPublicKeyError, WalletSignTransactionError } from '@solana/wallet-adapter-base';
import { getDerivationPath, getPublicKey, signTransaction as _signTransaction } from './util';
export var LedgerWalletAdapter = /*#__PURE__*/function (_BaseSignerWalletAdap) {
  _inherits(LedgerWalletAdapter, _BaseSignerWalletAdap);

  var _super = _createSuper(LedgerWalletAdapter);

  function LedgerWalletAdapter() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LedgerWalletAdapter);

    _this = _super.call(this);

    _this._disconnected = function () {
      var transport = _this._transport;

      if (transport) {
        transport.off('disconnect', _this._disconnected);
        _this._transport = null;
        _this._publicKey = null;

        _this.emit('error', new WalletDisconnectedError());

        _this.emit('disconnect');
      }
    };

    _this._derivationPath = config.derivationPath || getDerivationPath(0, 0);
    _this._connecting = false;
    _this._transport = null;
    _this._publicKey = null;
    return _this;
  }

  _createClass(LedgerWalletAdapter, [{
    key: "publicKey",
    get: function get() {
      return this._publicKey;
    }
  }, {
    key: "ready",
    get: function get() {
      return typeof window !== 'undefined' && !!navigator.hid;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this._connecting;
    }
  }, {
    key: "connected",
    get: function get() {
      return !!this._transport;
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var transport, publicKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.connected || this.connecting)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this._connecting = true;
                _context.prev = 4;
                _context.next = 7;
                return TransportWebHid.create();

              case 7:
                transport = _context.sent;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](4);
                throw new WalletConnectionError(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message, _context.t0);

              case 13:
                _context.prev = 13;
                _context.next = 16;
                return getPublicKey(transport, this._derivationPath);

              case 16:
                publicKey = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t1 = _context["catch"](13);
                throw new WalletPublicKeyError(_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message, _context.t1);

              case 22:
                transport.on('disconnect', this._disconnected);
                this._transport = transport;
                this._publicKey = publicKey;
                this.emit('connect');
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t2 = _context["catch"](0);
                this.emit('error', _context.t2);
                throw _context.t2;

              case 32:
                _context.prev = 32;
                this._connecting = false;
                return _context.finish(32);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 28, 32, 35], [4, 10], [13, 19]]);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var transport;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                transport = this._transport;

                if (!transport) {
                  _context2.next = 13;
                  break;
                }

                transport.off('disconnect', this._disconnected);
                this._transport = null;
                this._publicKey = null;
                _context2.prev = 5;
                _context2.next = 8;
                return transport.close();

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);
                this.emit('error', new WalletDisconnectionError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message, _context2.t0));

              case 13:
                this.emit('disconnect');

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 10]]);
      }));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var transport, publicKey, signature;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                transport = this._transport;
                publicKey = this._publicKey;

                if (!(!transport || !publicKey)) {
                  _context3.next = 5;
                  break;
                }

                throw new WalletNotConnectedError();

              case 5:
                _context3.prev = 5;
                _context3.next = 8;
                return _signTransaction(transport, transaction, this._derivationPath);

              case 8:
                signature = _context3.sent;
                transaction.addSignature(publicKey, signature);
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](5);
                throw new WalletSignTransactionError(_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message, _context3.t0);

              case 15:
                return _context3.abrupt("return", transaction);

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](0);
                this.emit('error', _context3.t1);
                throw _context3.t1;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18], [5, 12]]);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(transactions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var transport, publicKey, derivationPath, _iterator, _step, transaction, signature;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                transport = this._transport;
                publicKey = this._publicKey;

                if (!(!transport || !publicKey)) {
                  _context4.next = 5;
                  break;
                }

                throw new WalletNotConnectedError();

              case 5:
                _context4.prev = 5;
                derivationPath = this._derivationPath;
                _iterator = _createForOfIteratorHelper(transactions);
                _context4.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 18;
                  break;
                }

                transaction = _step.value;
                _context4.next = 14;
                return _signTransaction(transport, transaction, derivationPath);

              case 14:
                signature = _context4.sent;
                transaction.addSignature(publicKey, signature);

              case 16:
                _context4.next = 10;
                break;

              case 18:
                _context4.next = 23;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4["catch"](8);

                _iterator.e(_context4.t0);

              case 23:
                _context4.prev = 23;

                _iterator.f();

                return _context4.finish(23);

              case 26:
                _context4.next = 31;
                break;

              case 28:
                _context4.prev = 28;
                _context4.t1 = _context4["catch"](5);
                throw new WalletSignTransactionError(_context4.t1 === null || _context4.t1 === void 0 ? void 0 : _context4.t1.message, _context4.t1);

              case 31:
                return _context4.abrupt("return", transactions);

              case 34:
                _context4.prev = 34;
                _context4.t2 = _context4["catch"](0);
                this.emit('error', _context4.t2);
                throw _context4.t2;

              case 38:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 34], [5, 28], [8, 20, 23, 26]]);
      }));
    }
  }]);

  return LedgerWalletAdapter;
}(BaseSignerWalletAdapter);